import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  List,
  Grid,
  Card,
  CardHeader,
  ListItem,
  ListItemText,
  ListItemIcon,
  Checkbox,
  Button,
  Divider,
  Stack,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import _ from 'lodash';
import { BackButton } from '../../components/Button';
import * as actions from '../../redux/actions';
import { ViewTitle } from '../../components/ViewTitle';

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

export default function CreateManageWheel({ title, subtitle }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const wheel = useSelector((state) => state.wheel);
  const [checked, setChecked] = React.useState([]);
  const [left, setLeft] = React.useState(wheel?.rows);
  const [right, setRight] = React.useState([]);

  useEffect(() => {
    dispatch(actions.wheelAll({}));
    return () => {};
  }, []);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const numberOfChecked = (items) => intersection(checked, items).length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };
  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items.length && items.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items.length === 0}
            inputProps={{
              'aria-label': 'all items selected',
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${items.length} selected`}
      />
      <Divider />
      <List
        sx={{
          width: 450,
          height: 330,
          bgcolor: 'background.paper',
          overflow: 'auto',
        }}
        dense
        component="div"
        role="list"
      >
        {items.map((value) => {
          const labelId = `transfer-list-all-item-${value}-label`;

          return (
            <ListItem
              key={value}
              role="listitem"
              button
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={` ${value?.wheelNumber}`} />
            </ListItem>
          );
        })}
      </List>
    </Card>
  );

  const handleRetread = () => {
    alert('หล่อยาง');
  };

  const renderListSelect = () => (
    <Grid container spacing={2} alignItems="center">
      <Grid item>{customList('รายการยาง', left)}</Grid>
      <Grid item>
        <Grid container direction="column" alignItems="center">
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedRight}
            disabled={leftChecked.length === 0}
            aria-label="move selected right"
          >
            &gt;
          </Button>
          <Button
            sx={{ my: 0.5 }}
            variant="outlined"
            size="small"
            onClick={handleCheckedLeft}
            disabled={rightChecked.length === 0}
            aria-label="move selected left"
          >
            &lt;
          </Button>
        </Grid>
      </Grid>
      <Grid item>{customList('ยางที่เลือก', right)}</Grid>
      <Grid item>
        <Stack spacing={2}>
          <Button variant="contained" onClick={() => handleRetread(right)}>
            หล่อยาง
          </Button>
          <Button variant="contained" color="error">
            ลบ
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );

  const rederTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const backButton = () => <BackButton />;

  return (
    <div>
      {rederTitle()}
      {backButton()}
      <div className="lg:flex py-2">{renderListSelect()}</div>
    </div>
  );
}
CreateManageWheel.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

CreateManageWheel.defaultProps = {
  title: '',
  subtitle: '',
};
